import { DocumentMappingSavePayload, RequestPayload } from '../types/mec.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const deleteDocumentMappingAPI = async (id: number | null) => {
  return await axiosInstance.delete(
    `${API_END_POINT.CONSENT_REQUEST}document-consents/${id}`
  )
}
export const fetchPersonas = async (portalId: number | null) => {
  return await axiosInstance.get(
    `${API_END_POINT.CONSENT_REQUEST}consent-portals/${portalId}/personas`
  )
}
export const fetchTaggedPdfView = async (documentId: number | null) => {
  return await axiosInstance.get(
    `${API_END_POINT.CONSENT_REQUEST}document-consents/tagged-pdf?documentId=${documentId}`
  )
}
export const fetchTaggedPdfViewOnListing = async (
  documentId: number | null
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CONSENT_REQUEST}document-consents/draft-pdf?documentId=${documentId}`
  )
}
export const saveDocumentMappingData = async (
  payload: DocumentMappingSavePayload
) => {
  return await axiosInstance.put(
    `${API_END_POINT.CONSENT_REQUEST}document-consents`,
    payload
  )
}
export const fetchPdfTags = async (documentId: number | null) => {
  return await axiosInstance.get(
    `${API_END_POINT.CONSENT_REQUEST}document-consents/fetch-tags?documentId=${documentId}`
  )
}
export const fetchDocumentMappingDataById = async (
  documentId: number | null
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CONSENT_REQUEST}document-consents/${documentId}`
  )
}
export const fetchDocumentListingAPI = async (
  sortInfo: {
    sortKey: string
    sortDirection: string
  },
  page: number,
  size: number,
  payload: RequestPayload,
  portalId: number
) => {
  return await axiosInstance.post(
    `${
      API_END_POINT.CONSENT_REQUEST
    }document-consents/advance?consentPortalId=${portalId}&${
      sortInfo?.sortKey && sortInfo?.sortDirection
        ? `sort=${sortInfo?.sortKey},${sortInfo?.sortDirection}&`
        : ''
    }page=${page}&size=${size}`,
    payload
  )
}

export const fetchConsentExpirationData = async (
  value: string,
  isAttachment?: boolean,
  token?: string | null,
  _isMicrosite?: boolean
) => {
  const payload = {
    entity_name: 'category_values',
    select: ['value'],
    filters: [
      {
        criteria: [
          {
            values: [value],
            operation: isAttachment ? 'EQUALS' : 'LIKE',
            field_name: 'category',
          },
        ],
      },
    ],
  }
  if (isAttachment) {
    // might be used later
    // if (!isMicrosite && !token?.length) {
    //   return await axiosInstance.post(
    //     `${API_END_POINT.HCP}practices/enrollments/category_values`,
    //     payload,
    //     {
    //       ...(token?.length && {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }),
    //     }
    //   )
    // } else {
    return await axiosInstance.post(
      `${API_END_POINT.HCP}public/microsite/enhanced/enrollments/category_values`,
      payload,
      {
        ...(token?.length && {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      }
    )
    // }
  } else
    return await axiosInstance.post(
      `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/category_values`,
      payload
    )
}
